// extracted by mini-css-extract-plugin
export var link = "planer-scroll-to-day-btn-module--link--riUQE";